// This theme leverages CSS variables defined in GlobalStyles.js
const theme = {
  colors: {
    primary: 'var(--color-primary)',
    primaryLight: 'var(--color-primary-light)',
    primaryLighter: 'var(--color-primary-lighter)',
    primaryDark: 'var(--color-primary-dark)',
    background: 'var(--color-background)',
    backgroundSecondary: 'var(--color-background-secondary)',
    text: 'var(--color-text)',
    textSecondary: 'var(--color-text-secondary)',
    textLight: 'var(--color-text-light)',
    textMuted: 'var(--color-text-muted)',
    border: 'var(--color-border)',
    borderLight: 'var(--color-border-light)',
    accent: 'var(--color-accent)',
    accentLight: 'var(--color-accent-light)',
    accentDark: 'var(--color-accent-dark)',
    success: 'var(--color-success)',
    error: 'var(--color-error)',
    warning: 'var(--color-warning)',
    info: 'var(--color-info)'
  },
  spacing: {
    xs: 'var(--space-xs)',
    sm: 'var(--space-sm)',
    md: 'var(--space-md)',
    lg: 'var(--space-lg)',
    xl: 'var(--space-xl)'
  },
  fontSize: {
    xs: 'var(--font-size-xs)',
    sm: 'var(--font-size-sm)',
    md: 'var(--font-size-md)',
    lg: 'var(--font-size-lg)',
    xl: 'var(--font-size-xl)',
    xxl: 'var(--font-size-xxl)',
    '2xl': 'var(--font-size-2xl)',
    '3xl': 'var(--font-size-3xl)',
    '4xl': 'var(--font-size-4xl)'
  },
  fontWeight: {
    normal: 'var(--font-weight-normal)',
    medium: 'var(--font-weight-medium)',
    semibold: 'var(--font-weight-semibold)',
    bold: 'var(--font-weight-bold)'
  },
  borderRadius: {
    sm: 'var(--border-radius-sm)',
    md: 'var(--border-radius-md)'
  },
  shadows: {
    small: 'var(--shadow-small)',
    medium: 'var(--shadow-medium)',
    large: 'var(--shadow-large)'
  },
  transitions: {
    default: 'var(--transition-speed)'
  }
};

export default theme;
